export enum Permissions {
  BridgetAdministration = 'administration',
  BridgetSuper = 'super',
  JimboReader = 'reader',
  JimboSupplierConfiguration = 'supplier_configuration',
  JimboSpoOperation = 'spo_operation',
}
